import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
`;

export const Label = styled.label`
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #33303e;
  text-align: left;
`;

export const Field = styled.select<{ hasError: boolean }>`
  border: 1px solid rgba(140, 138, 151, 0.4);
  border-radius: 8px;
  padding: 14px;

  ${({ hasError }) => hasError && "border-color: #ff5e5e !important;"}

  /* muda a fonte do select em si */
  font-family: "Inter", sans-serif;

  /* muda a fonte de todas as opções */
  option {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    color: #333;
  }
`;


export const ValidateHelp = styled.p`
  text-align: left;
  font-size: 13px;
  margin: 8px 0;
  color: #ff5e5e;
`;
